var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('layout-left'),_c('div',{staticClass:"layout-content",class:{active:_vm.isCollapse}},[_c('layout-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }